import {
    getAccountBySourceId,
    getSelectedAccount,
    setSelectedAccount,
} from 'owa-account-source-list-store';
import type { MailboxInfo } from 'owa-client-types';
import { errorThatWillCauseAlertAndThrow } from 'owa-trace';
import { preSelectAccount } from './pluggableHost';

export function getSelectedSourceId(): string {
    let currentSelected = getSelectedAccount();
    if (!currentSelected) {
        errorThatWillCauseAlertAndThrow('NoAccountSelected');
    }

    return currentSelected!.sourceId;
}

/**
 * In the Reflow mode there is a selected account, this method returns the mailbox info
 * associated with the selected account.
 * @returns MailboxInfo for the selected account
 */
export function getSelectedMailboxInfo(): MailboxInfo {
    let currentSelected = getSelectedAccount();
    if (!currentSelected) {
        errorThatWillCauseAlertAndThrow('NoAccountSelected');
    }

    if (!currentSelected!.mailboxInfo) {
        errorThatWillCauseAlertAndThrow('SelectedAccountDoesNotHaveMailbox');
    }

    return currentSelected!.mailboxInfo!;
}

export async function setSelectedSourceId(sourceId: string): Promise<void> {
    const accountToSelect = getAccountBySourceId(sourceId);
    if (!accountToSelect) {
        errorThatWillCauseAlertAndThrow('SelectedAccountNotFound');
    }

    await preSelectAccount(sourceId);

    setSelectedAccount(sourceId);
}
